module.exports = __webpack_public_path__ + "static/img/icon-takeout-official.9e100751.png";